module.exports = __webpack_public_path__ + "img/404_pic.ec9a1432.png";